export default {
  SET_ENABLERS: 'setEnablers',
  SET_SELECTED_ENABLER: 'setSelectedEnabler',
  SET_FIELD_TENANTS: 'setFieldTenants',
  SET_FIELD_TYPES: 'setFieldTypes',
  SET_FIELD_PARAMS: 'setFieldParams',
}